import React, { FC, useState } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import PublicationListSetsTab from "./PublicationListSetsTab";
import PublicationListsBrowse from "./components/PublicationListsBrowse";

// ─── Styled components ───────────────────────────────────────────────────────

// Sized by its content — AppShellLayout's ContentArea is the scroll container,
// so the page must be allowed to grow past the viewport rather than clip.
const PageRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  padding: "0 0 32px",
});

const TabBar = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "inline-flex",
  gap: 4,
  padding: 4,
  borderRadius: 10,
  background: theme.palette.brand.gray100,
  alignSelf: "flex-start",
}));

const TabButton = styled("button")(({ theme }: { theme: Theme }) => ({
  border: "none",
  cursor: "pointer",
  background: "transparent",
  color: theme.palette.brand.gray500,
  fontSize: 13,
  fontWeight: 600,
  padding: "7px 16px",
  borderRadius: 8,
  transition: "all 0.15s ease",
  "&[data-active='true']": {
    background: theme.palette.brand.white,
    color: theme.palette.brand.gray900,
    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
  },
}));

const TabContent = styled("div")({
  display: "flex",
  flexDirection: "column",
});

// ─── Component ───────────────────────────────────────────────────────────────

type ActiveTab = "sets" | "lists";

const PublicationListsView: FC = () => {
  const [activeTab, setActiveTab] = useState<ActiveTab>("sets");

  return (
    <PageRoot>
      <TabBar>
        <TabButton type="button" data-active={activeTab === "sets"} onClick={() => setActiveTab("sets")}>
          Sets
        </TabButton>
        <TabButton type="button" data-active={activeTab === "lists"} onClick={() => setActiveTab("lists")}>
          Lists
        </TabButton>
      </TabBar>

      <TabContent>
        {activeTab === "sets" ? <PublicationListSetsTab /> : <PublicationListsBrowse showListActions />}
      </TabContent>
    </PageRoot>
  );
};

export default PublicationListsView;
